<template>
	<div>
		<p class="txt-list-title">OCR Template List</p>
		<div class="list-control-wrap">
			<input
				type="text"
				class="input-list-search"
				placeholder="Please enter the template name to search."
				@keyup="searchOcrTemplate($event.target.value)"
			/>
			<button
				v-if="workAccessCheck('CREATE') && !(projectStateCd == '4' || projectStateCd == '3')"
				type="button"
				class="btn-new"
				title="New Template"
				@click="doCreate()"
			>
				<img src="@/assets/images/common/btn_new.png" alt="" />
				New Template
			</button>
		</div>
		<table class="tb-list-vertical" style="table-layout: fixed;">
			<colgroup>
				<col width="5%" />
				<col width="13%" />
				<col width="auto" />
				<col width="13%" />
				<col width="13%" />
				<col width="13%" />
				<col width="7%" />
			</colgroup>
			<thead>
				<tr>
					<th>No</th>
					<th>Template Name</th>
					<th>Description</th>
					<th>Repeat Count</th>
					<th>Register </th>
					<th>Regist Date</th>
					<th>Function</th>
				</tr>
			</thead>
			<tbody>
				<tr
					v-for="(ocrTemplate, index) in ocrTemplateList"
					:key="index"
					tabindex="0"
					@click.stop="doEdit(ocrTemplate)"
				>
					<td>
						{{ index + 1}}
					</td>
					<td>
						{{ ocrTemplate.ocrName }}
					</td>
					<td class="ellipsis" :title="ocrTemplate.description">
						{{ ocrTemplate.description }}
					</td>
					<td>
						{{ ocrTemplate.repeatCnt }}
					</td>
					<td>
						{{ ocrTemplate.firstRegistUserId }}
					</td>
					<td >
						{{ ocrTemplate.firstRegistDate.substring(0, 10) }}
					</td>
					<td>
						<button
							v-if="workAccessCheck('DELETE') && !(projectStateCd == '4' || projectStateCd == '3')"
							type="button"
							class="btn-remove"
							title="Remove Template"
							@click.stop="doDelete(ocrTemplate)"
						></button>
					</td>
				</tr>
				<tr v-if="ocrTemplateList.length == 0">
					<td colspan="7" class="no-data">
						There is no registered OCR template, Please register the template.
					</td>
				</tr>
			</tbody>
		</table>
		<div class="pagination-wrap">
			<pagination
				:data="pagination"
				:show-disabled="true"
				:limit="4"
				@pagination-change-page="doSearchPage"
			>
				<button type="button" slot="prev-nav" class="page-prev">&lt;</button>
				<button type="button" slot="next-nav" class="page-next">&gt;</button>
			</pagination>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";

export default {
	name: "OcrList",
	components: {
	},
	beforeCreate(){
		let item = {
			userId: sessionStorage.getItem("userId"),
			privilegeTypeCd: "2",
			privilegeCategory: "OCR",
			privilegeName: "ACCESS",
			projectNo: this.$route.params.projectNo
		}
		this.$accessAuth(item).then((status) => {
			if(status == false){
				this.$router.go(-1);
				this.$alert("You are not authorized.","Warning","warning");
			}
		})
	},
	created() {
		this.logger.debug(this, "created()");
		this.item.projectNo = this.$route.params.projectNo;
		this.selectOcrTemplateList();
		this.getAccessList('OCR');
		this.getProjectStateCd();
	},
	data() {
		return {
			item: {},
			ocrTemplateList: [],
			pagination: {},
			screeningList: [],
			testScreeningList: [],
			accessList: [],
			projectStateCd: ""
		};
	},
	methods: {
		selectOcrTemplateList() {
			this.logger.debug(this, "selectOcrTemplateList()");
			this.item.projectNo = this.$route.params.projectNo;

			axios
				.post(this.config.contextRoot + "/ocr/selectList.do", this.item)
				.then((response) => {
					console.log(response);
					this.ocrTemplateList = response.data.ocrTemplateList;
					this.pagination = response.data.pagination;
					this.$nextTick(function () {
						setTimeout(function() {
							EventBus.$emit("project-loading", false);
						}.bind(this), 100);
					});
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doSearchPage(page) {
			this.logger.debug(this, "doSearchPage()");

			if (typeof page === "undefined" || page === 0) {
				page = 1;
			}
			this.item.pageNum = page;
			this.selectOcrTemplateList();
		},
		doCreate() {
			this.logger.debug(this, "doCreate()");

			let url = this.config.contextRoot + "/project/" + this.item.projectNo + "/ocr/create";
			if (this.$route.path !== url) {
				EventBus.$emit("project-loading", true);
				this.$router.push(url);
			}
		},
		doEdit(ocrTemplate) {
			this.logger.debug(this, "doEdit(ocrTemplate)");
			
			let url = this.config.contextRoot + "/project/" + this.item.projectNo + "/ocr/edit/" + ocrTemplate.ocrNo;
			if (this.$route.path !== url)
			{
				EventBus.$emit("project-loading", true);
				this.$router.push(url);
			}
		},
		selectScreening(visit) {
			this.logger.debug(this, "selectScreening()");

			axios
				.post(this.config.contextRoot + "/visit/selectScreening.do", {visitNo: visit.visitNo})
				.then((response) => {
					console.log(response);
					this.screeningList = response.data.screeningList;
					this.testScreeningList = response.data.testScreeningList;

					if(this.screeningList.length > 0 || this.testScreeningList.length > 0)
					{
						this.$alert("I can't delete the data because there's a screening.", "Warn", "warning");
						return;
					}
					else if(this.screeningList.length == 0)
					{
						this.doDelete(visit);
					}
					// test entry 사용자일시
					// if(this.testScreeningList.length > 0)
					// {
					// 	this.$alert("I can't delete the data because there's a testScreening.", "Warn", "warning");
					// 	return;
					// }
					// else if(this.testScreeningList.length == 0)
					// {
					// 	this.doDelete(visit);
					// }
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doDelete(ocrTemplate) {
			this.logger.debug(this, "doDelete(ocrTemplate)");
			
			let msg = "Are you sure you want to delete the ocr template?";
			this.$confirm(msg, "Question", "question").then(() => {
				EventBus.$emit("project-loading", true);
				
				var param = {
					ocrNo : ocrTemplate.ocrNo,
				}
				axios
					.post(this.config.contextRoot + "/ocr/delete.do", param)
					.then((response) => {
						console.log(response);
						location.reload();
					})
					.catch((error) => {
						this.exceptionHandler(this, error);
					});
			});
		},
		searchOcrTemplate(value) {
			this.logger.debug(this, "searchOcrTemplate(value)");
			this.item.ocrName = value;
			this.selectOcrTemplateList();
		},
		getAccessList(category){
			axios
				.post(this.config.contextRoot + "/access/getCategoryPrivilegeList.do", {privilegeCategory: category})
				.then((response) => {
					console.log(response);
					this.accessList = response.data.privilegeList;
					this.accessList.forEach((obj) =>{
						this.workCheck(obj);
					})
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		async workCheck(obj){
			let item = {};
			item = {
				userId: sessionStorage.getItem("userId"),
				projectNo: this.$route.params.projectNo,
				privilegeTypeCd: obj.privilegeTypeCd,
				privilegeCategory: obj.privilegeCategory,
				privilegeName: obj.privilegeName
			}
			obj.isAccess = await this.$accessAuth(item);
		},
		workAccessCheck(name){
			for(let  i = 0; i < this.accessList.length; i++){
				if(this.accessList[i].privilegeName == name){
					return this.accessList[i].isAccess;
				}
			}
		},
		getProjectStateCd() {
			// project 셋팅
			axios
				.post(this.config.contextRoot + "/project/select.do", {projectNo: this.$route.params.projectNo})
				.then((response) => {
					console.log(response);
					this.projectStateCd = response.data.item.projectStateCd;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
	}
};
</script>